import GameTime from "../time/GameTime";

export default class GameTimeSave {
    constructor() {
    }

    /**
     * @param {GameTime} gameTime 
     * @returns {Object}
     */
    static generateSave(gameTime) {
        const saveState = {};

        saveState.turn = gameTime.turnNumber;
        saveState.frame = gameTime.frameNumber;
        saveState.time = Date.now();

        return saveState;
    }

    /**
     * @param {GameTime} gameTime 
     * @param {Object} saveState 
     */
    static loadSave(gameTime, saveState) {
        if (!saveState) {
            return;
        }

        gameTime.turnNumber = saveState.turn;
        gameTime.saveTime = saveState.time;

        if (saveState.frame) {
            gameTime.frameNumber = saveState.frame;
        }
    }
}